// Styles
import 'normalize.css'
import 'primeflex/themes/primeone-light.css'
import 'primeflex/primeflex.css'
import 'typeface-inter'
import 'typeface-space-mono'
import '@/assets/markdown.css'

// Vue app
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router)

// FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas)
library.add(fab)
dom.watch()

// PrimeVue
import PrimeVue from 'primevue/config'
import Nora from '@primeuix/themes/nora'
import { definePreset } from '@primeuix/themes'
import ToastService from 'primevue/toastservice'

const customPreset = definePreset(Nora, {
  semantic: {
    primary: {
      50: '#f0f0f0',
      100: '#d9d9d9',
      200: '#b3b3b3',
      300: '#8c8c8c',
      400: '#666666',
      500: '#333333',
      600: '#2b2b2b',
      700: '#212121',
      800: '#171717',
      900: '#0d0d0d',
      950: '#050505',
    },
  },
})

app.use(PrimeVue, {
  theme: {
    preset: customPreset,
    options: {
      prefix: 'p-neutral',
      darkModeSelector: false,
    },
  },
})

app.use(ToastService)

// Mount
app.mount('#app')
